import React from 'react';

import { Grid } from '@ha/dsl';

import { normalizeAlgoliaListing } from 'ha/models/Listing/normalizeAlgoliaListing';
import { useMediaQuery } from 'ha/helpers/MediaQuery';

import ListingPreviewCardTracked from '../containers/ListingPreviewCardTracked';
import { SearchListing } from '../types';

type Props = {
  items: SearchListing[];
  dataTestLocator?: string;
};

const SearchResultsList: React.FC<Props> = ({
  items,
  dataTestLocator = '',
}) => {
  const { lg } = useMediaQuery();

  return (
    <React.Fragment>
      {items.map((room, index) => (
        <Grid
          item
          xs={12}
          sm={12}
          md={!lg ? 6 : 4}
          key={room.id}
          data-test-locator={`Search Results Item${dataTestLocator}`}
        >
          <ListingPreviewCardTracked
            listingId={room.id}
            room={normalizeAlgoliaListing(room)}
            isLazy={index >= 4}
            scrollableElement="window"
            bottomOffset="-90%"
            withGallery
            withFavorites
            trackLocation="search"
          />
        </Grid>
      ))}
    </React.Fragment>
  );
};

export default SearchResultsList;
